var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgUsersIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.875A1.867 1.867 0 0 0 11.869 2a1.872 1.872 0 1 0-3.744 0c0 1.038.838 1.875 1.875 1.875Zm-5 0A1.867 1.867 0 0 0 6.869 2a1.872 1.872 0 1 0-3.744 0c0 1.038.837 1.875 1.875 1.875Zm0 1.25c-1.456 0-4.375.731-4.375 2.188v.937c0 .344.281.625.625.625h7.5a.627.627 0 0 0 .625-.625v-.938c0-1.456-2.919-2.187-4.375-2.187Zm5 0a7.3 7.3 0 0 0-.606.031c.012.006.018.019.025.025.712.519 1.206 1.213 1.206 2.131v.938c0 .219-.044.431-.113.625h3.238a.627.627 0 0 0 .625-.625v-.938c0-1.456-2.919-2.187-4.375-2.187Z",
    fill: "#2E2E2E"
  })));
};
export { SvgUsersIcon as ReactComponent };
export default __webpack_public_path__ + "a27d787f082b2aaac96b15fb89bc707a.svg";